<script setup lang="ts">
import { useAppStore } from "@/stores/app";
//@ts-ignore
import Slideout from "@/components/elements/slideout.vue";
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";
import { XIcon } from "@heroicons/vue/solid";

const breakpoints = useBreakpoints(breakpointsTailwind);
const showNavigation = breakpoints.smaller("lg");

const appStore = useAppStore();

interface Link {
    link: {
        class: string;
        target: string;
        title: string;
        url: string;
    };
}

defineProps<{ links?: Link[]; contactLinks?: Link[]; uri: string; }>();
</script>

<template>
    <slideout name="navigation" :show="appStore.navigation.slideout.visible && showNavigation" :show-close="false" :inverse="true" @close="appStore.navigation.slideout.visible = false">
        <div class="container pt-[35px] flex justify-between items-center">
            <a href="/" class="mr-auto">
                <svg-vue icon="logo" class="w-auto h-[38px] fill-brown-100"></svg-vue>
                <span class="sr-only">{{ appStore.appName }}</span>
            </a>
            <button  @click="appStore.navigation.slideout.visible = false" class="">
                <XIcon class="h-[24px]"></XIcon>
            </button>
        </div>
        <div class="main-nav flex flex-col items-center justify-center flex-1 w-full space-y-6">
            <div class="!mt-10 flex flex-col space-y-6 items-center text-brown-200 font-helv font-medium">
                <a v-for="page in links" :href="page.link.url" class="mb-[20px]" :class="{ active: page.link.url === uri }">
                    {{ page.link.title }}
                </a>
            </div>
        </div>
        <div class="top-nav bg-brown-200 text-white h-[50px] w-full text-14 font-helv flex flex-wrap justify-center gap-[50px] items-center">
            <a v-for="page in contactLinks" :href="page.link.url" v-html="page.link.title"></a>
        </div>
    </slideout>
</template>
